var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-corner-right-down-icon lucide-corner-right-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 15 5 5 5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h7a4 4 0 0 1 4 4v12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCorner);
export default __webpack_public_path__ + "static/media/arrow-right-corner.3ee6a470cc36a381e8040307d3f2300b.svg";
export { ForwardRef as ReactComponent };